import React, { useEffect, useState } from "react";
import {
  Button,
  Fade,
  TextField,
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  InputAdornment,
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import axios from "axios";
import { toast } from "react-toastify";
import { decryptData } from "../../../../crypto";
import useStyles from "../../../../styles";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";

const PlanPopup = ({
  handleOpenClose,
  open,
  isConfirm,
  setIsConfirm,
  deleteExamPermanently,
  id,
  setLoading,
  selectedRowData
}) => {
  const classes = useStyles();
  const decryptedToken = decryptData(sessionStorage.getItem("token"));

  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleToggleShowPassword = () => setShowPassword(!showPassword);

  const handleStatus = async () => {
    if (!password) {
      toast.error("Please enter a password.");
      return;
    }

    try {
      const checkPasswordData = { user: { password } };

      const passwordCheckResponse = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/check/password`,
        checkPasswordData,
        { headers: { Authorization: `Bearer ${decryptedToken}` } }
      );

      if (!passwordCheckResponse.data.success) {
        toast.error("Invalid password. Please try again.");
        return;
      }

      deleteExamPermanently(id);
      handleOpenClose();
    } catch (error) {
      console.error("Error changing learner status:", error);
      toast.error("Invalid password. Please try again.");
    }
  };

  useEffect(() => {
    setPassword("");
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={handleOpenClose}
      maxWidth="sm"
      fullWidth
      TransitionComponent={Fade}
      PaperProps={{
        className: `${classes.p1} ${classes.bgwhite} ${classes.dflex} ${classes.flexdirectioncolumn}`,
        style: { borderRadius: "12px", padding: "10px" },
      }}
    >
      <DialogTitle
        className={`${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
        style={{ textAlign: "center" }}
      >
        {isConfirm
          ? "Enter Your Password"
          : `Are you confirm to delete ${selectedRowData?.exam_name} Permanently ?`}
      </DialogTitle>
      {isConfirm ? (
        <DialogContent>
          <TextField
            fullWidth
            type={showPassword ? "text" : "password"}
            variant="outlined"
            required
            placeholder="********"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleToggleShowPassword} edge="end">
                    {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <div
            className={`${classes.dflex} ${classes.justifyflexend} ${classes.mt1}`}
            style={{ marginTop: "16px" }}
          >
            <Button
              className={classes.custombtnoutline}
              onClick={handleOpenClose}
            >
              Cancel
            </Button>
            <Button
              className={classes.custombtnblue}
              onClick={handleStatus}
              //   style={{ marginLeft: "5px" }}
            >
              Submit
            </Button>
          </div>
        </DialogContent>
      ) : (
        <DialogContent>
          <div
            className={`${classes.dflex} ${classes.justifyflexend} ${classes.mt1}`}
            style={{ marginTop: "16px" }}
          >
            <Button
              className={classes.custombtnoutline}
              onClick={handleOpenClose}
            >
              No
            </Button>
            <Button
              className={classes.custombtnblue}
              onClick={() => setIsConfirm(true)}
              //   style={{ marginLeft: "5px" }}
            >
              Yes
            </Button>
          </div>
        </DialogContent>
      )}
    </Dialog>
  );
};

export default PlanPopup;
